var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tagType == "radio"
    ? _c(
        "a-radio-group",
        {
          attrs: { value: _vm.getValueSting, disabled: _vm.disabled },
          on: { change: _vm.handleInput }
        },
        [
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey === undefined ||
              item.langKey === null ||
              item.langKey === ""
              ? _c("a-radio", { key: key, attrs: { value: item.value } }, [
                  _vm._v(_vm._s(item.text))
                ])
              : _vm._e()
          }),
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey !== undefined &&
              item.langKey !== null &&
              item.langKey !== ""
              ? _c("a-radio", { key: key, attrs: { value: item.value } }, [
                  _vm._v(_vm._s(_vm.language[item.langKey] || item.text))
                ])
              : _vm._e()
          })
        ],
        2
      )
    : _vm.tagType == "radioButton"
    ? _c(
        "a-radio-group",
        {
          attrs: {
            buttonStyle: "solid",
            value: _vm.getValueSting,
            disabled: _vm.disabled
          },
          on: { change: _vm.handleInput }
        },
        [
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey === undefined ||
              item.langKey === null ||
              item.langKey === ""
              ? _c(
                  "a-radio-button",
                  { key: key, attrs: { value: item.value } },
                  [_vm._v(_vm._s(item.text))]
                )
              : _vm._e()
          }),
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey !== undefined &&
              item.langKey !== null &&
              item.langKey !== ""
              ? _c(
                  "a-radio-button",
                  { key: key, attrs: { value: item.value } },
                  [_vm._v(_vm._s(_vm.language[item.langKey] || item.text))]
                )
              : _vm._e()
          })
        ],
        2
      )
    : _vm.tagType == "select"
    ? _c(
        "a-select",
        {
          attrs: {
            "show-search": _vm.showSearch,
            "filter-option": _vm.filterOption,
            allowClear: _vm.allowClear,
            getPopupContainer: _vm.getPopupContainer,
            placeholder: _vm.placeholder,
            disabled: _vm.disabled,
            value: _vm.getValueSting
          },
          on: { change: _vm.handleInput }
        },
        [
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey === undefined ||
              item.langKey === null ||
              item.langKey === ""
              ? _c(
                  "a-select-option",
                  { key: key, attrs: { value: item.value } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "inline-block", width: "100%" },
                        attrs: { title: item.text || item.label }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(item.text || item.label) +
                            "\n      "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          }),
          _vm._l(_vm.dictOptions, function(item, key) {
            return item.langKey !== undefined &&
              item.langKey !== null &&
              item.langKey !== ""
              ? _c(
                  "a-select-option",
                  { key: key, attrs: { value: item.value } },
                  [
                    _c(
                      "span",
                      {
                        staticStyle: { display: "inline-block", width: "100%" },
                        attrs: { title: _vm.language[item.langKey] }
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.language[item.langKey]) +
                            "\n      "
                        )
                      ]
                    )
                  ]
                )
              : _vm._e()
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }